import { gql } from "@apollo/client"
import { skipToken, useQuery } from "@apollo/client/react"
import { getUserBehaviours, getUserBehavioursVariables } from "./__generated-typings__/useUserBehaviours"

const getUserBehavioursQuery = gql`
  query getUserBehaviours($user_id: String!, $event_label: String!) {
    user_behaviours(user_id: $user_id, event_label: $event_label) {
      event_label
      value
    }
  }
`

export const useUserBehaviours = (id: string | undefined, event: string) => {
  const {
    data: userBehaviours,
    error,
    loading
  } = useQuery<getUserBehaviours, getUserBehavioursVariables>(
    getUserBehavioursQuery,
    id && event
      ? {
          fetchPolicy: "network-only",
          variables: {
            user_id: id,
            event_label: event
          }
        }
      : skipToken
  )

  return { userBehaviours, error, loading }
}
